module.exports = __webpack_public_path__ + "static/media/promo.59c242a9.png";